<cec-menu
  [title]="'Competitions' | translate"
  [dataSource]="service"
  (onItemClicked)="onClickItem($event)"
  (onCloseSideNav)="closeSideNav()"
></cec-menu>

<cec-competition-registration-dialog
  #registrationDialog
></cec-competition-registration-dialog>

<cec-annual-registration-dialog #annualDialog></cec-annual-registration-dialog>

<cec-confirmation-dialog
  messageKey="LogoutCrewFromCompetition"
  (onButtonClicked)="deleteCompetitionRegistration($event)"
></cec-confirmation-dialog>
